module.exports = __webpack_public_path__ + "1e2f453341a5ea65700393104126e3e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-3.png
// module id = 2982
// module chunks = 0